import { onFindPivotPreviewItemsSuccess } from '../actions/internalActions';
import { mutator } from 'satcheljs';
import store from '../store/Store';
import Message from 'owa-service/lib/contract/Message';

mutator(onFindPivotPreviewItemsSuccess, actionMessage => {
    if (!actionMessage.items || actionMessage.items.length === 0) {
        return;
    }

    // make string array of senders
    const senders = actionMessage.items.map(item => {
        const message = item as Message;

        if (message.Sender) {
            return message.Sender.Mailbox.Name;
        }
        return null;
    });

    // Dedupe and grab first 3 items
    const uniqueSenders = senders
        .filter((sender, index) => senders.indexOf(sender) === index)
        .slice(0, 3);

    for (const pivot of store.enabledDisabledPivots) {
        if (pivot.InboxClassificationFilter === actionMessage.inboxClassificationFilter) {
            pivot.recentSenders = uniqueSenders;
        }
    }
});
